'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _nukaCarousel = require('nuka-carousel');

var _nukaCarousel2 = _interopRequireDefault(_nukaCarousel);

var _components = require('components');

var _reactRouter = require('react-router');

var _reactTimeago = require('react-timeago');

var _reactTimeago2 = _interopRequireDefault(_reactTimeago);

var _config = require('../../config');

var _config2 = _interopRequireDefault(_config);

var _SliderDecorator = require('./SliderDecorator');

var _SliderDecorator2 = _interopRequireDefault(_SliderDecorator);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var OutfitPreview = (_temp = _class = function (_Component) {
  (0, _inherits3.default)(OutfitPreview, _Component);

  function OutfitPreview(props) {
    (0, _classCallCheck3.default)(this, OutfitPreview);

    var _this = (0, _possibleConstructorReturn3.default)(this, (0, _getPrototypeOf2.default)(OutfitPreview).call(this, props));

    _this.state = {
      outfeat: _this.props.outfeat
    };
    return _this;
  }

  (0, _createClass3.default)(OutfitPreview, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var styles = require('./OutfeatPreview.scss');
      var outfeat = this.state.outfeat;


      var baseUrl = _config2.default.thumbnailAssetsUrl; //'https://s3.amazonaws.com/outfeats-thumbnails/';
      return _react2.default.createElement(_reactRouter.Link, {
        className: styles.container,
        style: { backgroundImage: 'url(' + baseUrl + outfeat.images[0] + ')' },
        to: "/" + outfeat.id, onClick: function onClick() {
          return _this2.props.onSelect(outfeat.user ? outfeat.user.id : '');
        } });
    }
  }]);
  return OutfitPreview;
}(_react.Component), _class.propTypes = {
  outfeat: _react.PropTypes.object
}, _temp);
exports.default = OutfitPreview;
module.exports = exports['default'];


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/OutfeatPreview/OutfeatPreview.js
 ** module id = 1103
 ** module chunks = 0
 **/